import { makeStyles } from "@mui/styles";

import FormPhoneField from "@/components/UI/FormPhoneField/FormPhoneField";
import FormTextField from "@/components/UI/FormTextField";

const useStyles = makeStyles((theme) => ({
  textField: {
    backgroundColor: theme.palette.semanticSurface.dark,
    borderTopLeftRadius: 6,
    borderTopRightRadius: 6,
    borderBottom: `2px ${theme.palette.semanticNeutral.light} solid`,
    "& label": {
      color: theme.palette.semanticNeutral.light,
    },
    "& label.Mui-focused": {
      color: `${theme.palette.semanticSurface.light} !important`,
    },
    "& .MuiInputBase-root": {
      backgroundColor: "transparent",
      color: "#fff",
    },
    "& .MuiInputBase-input": {
      paddingTop: "24px",
    },
    "& .MuiInputBase-inputMultiline": {
      paddingTop: "4px",
    },
    "& #country-select-demo": {
      marginBottom: "20px",
    },
  },
  formPhoneField: {
    marginTop: "16px",
    marginBottom: "8px",

    "& .MuiSvgIcon-root": {
      color: "#A2A2A2",
    },
    "& .phone-label": {
      left: "90px",
      fontSize: "1.1rem",
    },
    "& .MuiInputBase-root": {
      paddingBottom: "4px",
    },
  },
}));

export default function AddMessageFormV2(props) {
  const { handleSubmit, control, getValues, setValue, validate } = props;

  const classes = useStyles();

  const renderTextField = (options) => {
    const { name, label, inputProps } = options;
    return (
      <FormTextField
        fullWidth
        data-testId={name}
        name={name}
        label={label}
        size="small"
        variant="filled"
        control={control}
        className={classes.textField}
        inputProps={
          inputProps || {
            autoComplete: "none",
          }
        }
        onBlur={validate}
      />
    );
  };
  const renderFormPhoneField = (options) => {
    const { name, label, inputProps } = options;
    return (
      <FormPhoneField
        inputProps={
          inputProps || {
            autoComplete: "none",
          }
        }
        InputLabelProps={{
          className: "phone-label",
        }}
        className={`${classes.textField} ${classes.formPhoneField}`}
        data-testId={name}
        fullWidth
        variant="filled"
        control={control}
        name={name}
        setValue={setValue}
        label={label}
        size="small"
        defaultValue={getValues(name)}
        onBlur={validate}
      />
    );
  };

  const renderTextareaField = (options) => {
    const { name, label } = options;

    return (
      <FormTextField
        data-testId={name}
        className={classes.textField}
        fullWidth
        name={name}
        control={control}
        placeholder="Enter a message"
        multiline
        label={label}
        size="small"
        variant="filled"
        inputProps={{
          autoComplete: "none",
        }}
      />
    );
  };

  return (
    <form onSubmit={handleSubmit}>
      {renderTextField({
        name: "name",
        label: "Name",
      })}
      {renderFormPhoneField({
        name: "phone",
        label: "Phone",
      })}
      {renderTextField({
        name: "email",
        label: "Email",
        inputProps: {
          autoComplete: "none",
          style: { borderColor: "#fff !important" },
        },
      })}
      {renderTextareaField({ name: "message", label: "Message" })}
    </form>
  );
}
